export default __webpack_public_path__ + "static/media/08.3475c0c5.jpg";